import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Phone, ShieldCheck } from 'lucide-react';
import { heroImage, company } from '../../mock';
import { Button } from '../ui/button';

const Hero = () => {
  return (
    <section className="relative overflow-hidden bg-white">
      <div className="blob w-96 h-96 bg-brand-mint/30 -top-32 -left-24" />
      <div className="blob w-96 h-96 bg-pink-200/40 top-40 -right-32" />

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 pt-16 lg:pt-24 pb-20 lg:pb-28 grid lg:grid-cols-2 gap-14 items-center">
        <div className="animate-fadeUp">
          <span className="inline-flex items-center gap-2 rounded-full bg-brand-blue-light text-brand-blue font-semibold text-sm px-4 py-1.5 mb-6">
            <ShieldCheck className="w-4 h-4" /> Trusted care across Ireland
          </span>
          <h1 className="font-heading font-bold text-slate-900 text-4xl md:text-5xl xl:text-6xl leading-[1.08]">
            {company.heroLead}<br />
            <span className="text-brand-blue">{company.heroHighlight}</span>
          </h1>
          <p className="mt-6 text-slate-600 text-lg font-body max-w-xl leading-relaxed">
            {company.subTagline}
          </p>

          <div className="mt-9 flex flex-wrap gap-4">
            <Button asChild className="bg-brand-blue hover:bg-brand-blue-dark text-white font-semibold h-13 px-8 py-6 rounded-full text-base">
              <Link to="/contact" className="inline-flex items-center gap-2">Arrange care <ArrowRight className="w-4 h-4" /></Link>
            </Button>
            <Button asChild variant="outline" className="border-2 border-slate-200 hover:border-brand-blue text-slate-800 font-semibold h-13 px-8 py-6 rounded-full text-base bg-white">
              <Link to="/careers">Join our team</Link>
            </Button>
          </div>
        </div>

        <div className="relative animate-fadeUp" style={{ animationDelay: '0.15s' }}>
          <div className="relative rounded-[2rem] overflow-hidden shadow-2xl">
            <img src={heroImage} alt="Care professionals" className="w-full h-[440px] lg:h-[520px] object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-brand-blue-dark/40 to-transparent" />
          </div>

          <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl p-5 flex items-center gap-4 max-w-[240px]">
            <div className="w-12 h-12 rounded-xl bg-brand-blue flex items-center justify-center shrink-0">
              <Phone className="w-5 h-5 text-white" />
            </div>
            <div>
              <p className="text-xs text-slate-500 font-body">Speak to our team</p>
              <p className="font-heading font-bold text-slate-900 text-sm">{company.primaryPhone}</p>
            </div>
          </div>

          <div className="absolute -top-5 right-6 bg-brand-mint text-brand-blue-dark rounded-2xl shadow-xl px-5 py-3 font-heading font-bold hidden sm:block">
            100% Garda-vetted
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
